"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = void 0;
var _Tabs = _interopRequireWildcard(require("./index.parts"));
exports.Tabs = _Tabs;